import Vue from "vue";
import VueJsonLD from "vue-jsonld";

Vue.use(VueJsonLD);
